import React, { Component } from 'react';
import Page from '../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label
} from 'reactstrap';

import Isvg from 'react-inlinesvg'
import { Link } from 'react-router-dom'

import edit from '../../assets/svg/edit.svg'
import garabage from '../../assets/svg/garbage.svg'
import addIcon from '../../assets/svg/add-icon.svg';

import ListBuilder from '../../components/listBuilder';
import DeleteModal from '../../components/deleteModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT, DOMAINS } from '../../constants';
import ErrorModal from '../../components/errorModal';

import duplicateIcon from '../../assets/svg/duplicate-icon.svg';
import generateLinkIcon from '../../assets/svg/generate_link_icon.svg';


import InfoModal from '../../components/infoModal';
import Checkbox from '../../components/forms/fields/checkbox';
import Toggle from '../../components/forms/fields/toggle';



function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class InformationPages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            items: [],
            total: 0,
            loading: true
        };
    }


    get = () => {
        this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));

        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, groupId: this.props.selectedGroup })).then((data) => {
                this.setState({
                    ...data,
                    loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](window.fetch, this.props.lang, this.props[0].match, this.state.useState ? this.state.params : getSearchParams(this.props[0].location.search, { entries: 10, page: 0, groupId: this.props.selectedGroup })).then((data) => {
                let dataToSet = { ...data }
                if (dataToSet.page || dataToSet.items || dataToSet.total) {
                    dataToSet.loading = null;
                    // console.log(dataToSet.page || dataToSet.items || dataToSet.total)
                    let checkFilter = '';
                    if (dataToSet.resultFilter) {
                        checkFilter = String(dataToSet.resultFilter)
                        delete dataToSet.resultFilter;
                    }
                    let search = this.props[0].location.search;
                    let serachParams = getSearchParams(search);
                    let searchParamsFilter = '';
                    if (serachParams.filter) {
                        searchParamsFilter = serachParams.filter;
                    }
                    if (searchParamsFilter != checkFilter) {
                        delete dataToSet.page;
                        delete dataToSet.items;
                        delete dataToSet.total;
                        delete dataToSet.loading;
                    }
                }
                this.setState({
                    ...dataToSet,
                    // loading: null
                }, () => {
                    this.props.updateMeta(this.props.generateSeoTags(this.state, this.props.lang));
                })
            })
        }


    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }


        if (prevProps.selectedGroup != this.props.selectedGroup) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })

        }
    }


    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, [{ name: 'sortField', value: field }, { name: 'sortType', value: type }], false));

        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0 }, fields, restart));
        }
    }




    stopAnimation = () => {
        this.player.current.play();
    }


    delete = (id) => {
        this.setState({
            loading: true
        }, () => {

            fetch(API_ENDPOINT + '/landing/information-pages/' + id, {
                method: 'DELETE',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
            }).then(parseJSON).then(({ result, status }) => {
                if (result.error) {
                    this.setState({ error: result.error })
                }
                this.get();
            })
        })

    }
    setEdit = (item) => {
        this.props[0].history.push(`/my-data/information-pages/` + item._id)
    }

    duplicateModal = () => {
        let duplicateModal = { ...this.state.duplicateModal };
        duplicateModal.isPrivate = duplicateModal._isPrivate ? duplicateModal._isPrivate : false;
        delete duplicateModal._isPrivate;
        let obj = JSON.parse(JSON.stringify(duplicateModal));
        obj.title = obj.title + ' (copy)';
        delete obj._id;

        this.setState({ loadingDuplicate: true }, () => {
            fetch(API_ENDPOINT + '/landing/information-pages/new', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(obj)
            }).then(parseJSON).then(({ result, status }) => {
                if (status >= 200 && status < 300) {
                    this.setState({
                        duplicateModal: null,
                        loadingDuplicate: false
                    }, () => this.get())

                }

            })
        })
    }
    updatePrivateStatus = (item) => {
        if (!item || !item._id) return;
        const id = item?._id;
        const groupId = this.props.selectedGroup;
        const isPrivate = item?.isPrivate ? false : true;

        let obj = {
            groupId: groupId,
            isPrivate: isPrivate
        }

        fetch(API_ENDPOINT + `/landing/information-pages/${id}`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {
            if (result?.error) {
                this.setState({ error: result.error });
            } else {
                this.get();
            }
        })
    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = this.props.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }


    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }
        const groupData = this.getGroupData();
        const groupAlias = groupData?.alias;

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>

                <Container fluid>
                    {this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}

                        >
                            {this.state.error.translate(this.props.lang)}
                        </ErrorModal>

                        : null}

                    <Row>
                        <Col xl="12">
                            <div className="panel">
                                <div className="panel-header landing-builder-styles-header-container">
                                    <h5 className="component-header">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}</h5>
                                    <div className="landing-builder-styles-header">

                                        <Link to="/my-data/information-pages/new">
                                            <button className="btn add-button" ><Isvg src={addIcon} /> {'Add'.translate(this.props.lang)}</button>
                                        </Link>
                                    </div>

                                </div>
                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={this.state.loading}
                                    total={this.state.total}
                                    showNumeration={false}
                                    fields={
                                        [
                                            { type: 'text', name: 'title', label: 'Title'.translate(this.props.lang), allowSort: true },
                                            { type: 'text', name: 'slug', label: 'Slug'.translate(this.props.lang), allowSort: true },
                                            { type: 'text', name: 'isPrivate', label: 'Is Private'.translate(this.props.lang), allowSort: true }
                                        ]
                                    }
                                    items={this.state.items.map((item, idx) => {
                                        return {
                                            ...item,
                                            _isPrivate: item.isPrivate ? item.isPrivate : false,
                                            isPrivate:
                                                <div style={{ height: 33, width: 100, marginTop: -18 }}>
                                                    <Toggle
                                                        value={item.isPrivate ? item.isPrivate : false}
                                                        onChange={(e) => { this.updatePrivateStatus(item) }}
                                                    />
                                                </div>
                                        }
                                    })}
                                    actions={
                                        [
                                            {
                                                renderComponent: (item) =>
                                                    <div className="tabel-action-tooltip">
                                                        <Isvg src={generateLinkIcon} className={this.state.copiedToClipboard === item._id ? "duplicate-icon-active" : "duplicate-icon"} />
                                                        {
                                                            this.state.copiedToClipboard === item._id ?
                                                                <div style={{ visibility: 'visible' }} className="chat-icons-tooltip">{'Link copied to the clipboard'.translate(this.props.lang)}</div>
                                                                :
                                                                <div className="chat-icons-tooltip">{'Generate link'.translate(this.props.lang)}</div>
                                                        }

                                                    </div>,
                                                onClick: (item) => {
                                                    const slug = item?.slug;
                                                    if (!groupAlias || !slug) return;
                                                    let link;
                                                    if (typeof window !== 'undefined' && item) {
                                                        let endpoint = window.origin;

                                                        if (endpoint) {
                                                            link = `${endpoint}/${groupAlias}/page/${slug}`;
                                                            navigator.clipboard.writeText(link)
                                                        }
                                                    }
                                                    //
                                                    if (link) {
                                                        this.setState({ copiedToClipboard: item?._id }, () => {
                                                            if (this.copyToClipboard) {
                                                                clearTimeout(this.copyToClipboard)
                                                            }
                                                            this.copyToClipboard = setTimeout(() => {
                                                                this.setState({ copiedToClipboard: false })
                                                            }, 2000);
                                                        })
                                                    }
                                                },
                                                condition: (item) => {
                                                    if (item?.slug && groupAlias) {
                                                        return true
                                                    } else {
                                                        return false
                                                    }

                                                }
                                            },

                                            {
                                                component: <Isvg src={duplicateIcon} className="duplicate-icon" style={{ marginRight: 25 }} />,
                                                onClick: (item) => this.setState({ duplicateModal: item })
                                            },
                                            {
                                                component: <Isvg src={edit} className="edit-icon" />,
                                                onClick: (item) => this.setEdit(item)
                                            },
                                            {
                                                component: <Isvg src={garabage} className="delete-icon" />,
                                                onClick: (item) => this.setState({ deleteModal: item })
                                            },
                                        ]
                                    }
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                ></ListBuilder>
                                <DeleteModal
                                    lang={this.props.lang}
                                    isOpen={this.state.deleteModal}
                                    toggle={() => this.setState({ deleteModal: null })}
                                    handler={() => { this.delete(this.state.deleteModal._id); this.setState({ deleteModal: null }) }}
                                >
                                    {'Delete template'.translate(this.props.lang)} <strong>{this.state.deleteModal && this.state.deleteModal.title}</strong>?
                                </DeleteModal>
                                {this.state.duplicateModal ?
                                    <InfoModal
                                        isOpen={this.state.duplicateModal}
                                        toggle={() => this.setState({ duplicateModal: !this.state.duplicateModal })}
                                        header={'Duplicate form'.translate(this.props.lang)}
                                        info={`Do you want to duplicate the information page`.translate(this.props.lang) + ' (' + this.state.duplicateModal.title + ')?'}
                                        buttons={[
                                            <Button color="primary" style={{ margin: 10 }} disabled={this.state.loadingDuplicate} onClick={() => this.duplicateModal()}>{'Yes'.translate(this.props.lang)}</Button>,
                                            <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ duplicateModal: false })}>{'No'.translate(this.props.lang)}</Button>

                                        ]}

                                    />
                                    :
                                    null
                                }


                            </div>
                        </Col>
                    </Row>



                </Container>


            </div>
        );
    }
}

export default Page(InformationPages);